export default "__VITE_ASSET__BbWPGBWI__"